/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState, FormEvent, ChangeEvent } from 'react'
import { useDispatch } from 'react-redux'
import './style.css'
import { SketchPicker } from 'react-color'
import axios from 'axios'
import { matchConsumerId } from '../../utility'
import { shallowEqual, useSelector } from 'react-redux'
import { RootState } from '../../../../setup'
import * as auth from '../../../../app/modules/auth/redux/AuthRedux'
import { NotificationContainer, NotificationManager } from 'react-notifications';
import { toAbsoluteUrl } from '../../../../_metronic/helpers'


export function Branding() {
  const [loading, setLoading] = useState(false)
  const dispatch = useDispatch()
  const user: any = useSelector<RootState>(({ auth }) => auth.user, shallowEqual) as any
  const [files, setFiles] = useState<{ [key: string]: File }>({}); // Explicitly type files
  const [logoLink, setLogoLink] = useState('')
  const [bgColor, setBgColor] = useState('#222')
  const [disable, setDisable] = useState(true);
  const [bgImageLink, setBgImageLink] = useState('');
  const [logoImageLink, setLogoImageLink] = useState('');

  const onSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (logoLink || bgColor || files['bg_image']) {
      setLoading(true);
      const formData = new FormData();
      formData.append('bgColor', bgColor);

      let isLogoValid = true;
      let isBGValid = true;
      const logoMxSize = 100000; // 100KB
      const bgMxSize = 200000;   // 200KB
      let message = '';

      if (files['logo_img'] && files['logo_img'].size > logoMxSize) {
        message = `Logo image size should be less than 100KB.`;
        isLogoValid = false;
      }
      if (files['bg_image'] && files['bg_image'].size > bgMxSize) {
        message = `Background image size should be less than 200KB.`;
        isBGValid = false;
      }

      if (!isLogoValid || !isBGValid) {
        NotificationManager.info(message, '', 5000);
        setLoading(false);
        return false;
      }

      // Append files if they exist
      if (files['logo_img']) {
        formData.append('logo_img', files['logo_img']);
      }
      if (files['bg_image']) {
        formData.append('bg_image', files['bg_image']);
      } else if (bgImageLink) {
        formData.append('bgImageLink', bgImageLink);
      }

      if (files['logo_img']) {
        formData.append('logo_img', files['logo_img']);
      } else if (logoImageLink) {
        formData.append('logoImageLink', logoImageLink);
      }

      formData.append('logoLink', logoLink || '');
      formData.append('consumerId', user.user.consumerId);

      axios
        .post(`${process.env.REACT_APP_API_URL_BACKEND_LOCAL}/branding-preview`, formData)
        .then((response) => {
          setLoading(false);
          NotificationManager.success('Meeting UI settings have been updated successfully!', '', 5000);
        })
        .catch((error) => {
            console.error("Error submitting branding settings:", error);
            NotificationManager.error('Failed to update meeting UI settings.', '', 5000);
            setLoading(false);
        })
    } else {
      NotificationManager.info('Please select a logo, background image, or background color.', '', 5000);
    }
  }

  const { user: { consumerId } } = user;
  
  useEffect(() => {
    if (consumerId) {
      matchConsumerId(consumerId, dispatch, auth);
      axios.get(`${process.env.REACT_APP_API_URL_BACKEND_LOCAL}/consumer/branding-details/${consumerId}`)
        .then(res => {
          const data = res.data;
          const { backgroundColor, logoClickUrl, logoImageUrl, backgroundImageUrl } = data;
          if (backgroundColor) {
            setBgColor(backgroundColor);
          }
          setLogoLink(logoClickUrl || '');
          if (logoImageUrl) {
            setLogoImageLink(logoImageUrl);
          } 
          if (backgroundImageUrl) {
            setBgImageLink(backgroundImageUrl);
          }
        })
        .catch(err => {
          console.error("Error fetching branding details:", err);
        })
    }
  }, [consumerId, dispatch]);

  const changeHandlerLogo = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      if (!file.type.startsWith('image/')) {
        NotificationManager.error('Only image files are allowed for the logo.', '', 5000);
        event.target.value = ''; // Clear the input
        return;
      }
      setFiles(prev => ({
        ...prev,
        logo_img: file,
      }));
      setDisable(false);
    }
  }

  const changeHandlerBG = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      if (!file.type.startsWith('image/')) {
        NotificationManager.error('Only image files are allowed for the background image.', '', 5000);
        event.target.value = ''; // Clear the input
        return;
      }
      setFiles(prev => ({
        ...prev,
        bg_image: file,
      }));
      setBgColor(''); // Clear background color if an image is uploaded
      setBgImageLink(''); // Clear existing background image link
      setDisable(false);
    }
  }

  const logoLinkOnChange = (event: ChangeEvent<HTMLInputElement>) => {
    setLogoLink(event.target.value);
    setDisable(false);
  }

  const handleBrandingVariation = (color: { hex: string }) => { // Correct type for TwitterPicker onChange
    setBgColor(color.hex);
    setBgImageLink(''); // Clear background image if color is selected
    setDisable(false);
    // Remove bg_image from files if a color is selected
    if (files['bg_image']) {
      const newFiles = { ...files };
      delete newFiles['bg_image'];
      setFiles(newFiles);
    }
  }

  return (
    <>
      <NotificationContainer />
      <header id='header'>
        <div className='container-fluid'>
          <div className='row justify-content-center'>
            <div className='col-lg-12'>
              <div className='row'>
                <div className='col-md-5'>
                  <form className='form' onSubmit={onSubmit}>
                    <div className='card-body'>
                      <div className='form-group'>
                        <label>Brand or Company Logo:</label>
                        <input
                          type='file'
                          name='logo_img'
                          accept='image/*'
                          className='form-control'
                          onChange={changeHandlerLogo}
                        />
                        <span className='form-text'>File size, up to 100KB. Will be visible to all the users and in the recordings.</span>
                      </div>
                      <div className='separator' />
                      
                      <div className='form-group'>
                        <label>Logo Click URL:</label>
                        <input
                          type='text'
                          value={logoLink}
                          className='form-control'
                          placeholder='e.g. https://yourbrand.com'
                          name='logo_link'
                          onChange={logoLinkOnChange}
                        />
                        <span className='form-text'>Opens a new tab with this URL when someone clicks on the Logo.</span>
                      </div>
                      <div className='separator' />

                      <div className='form-group'>
                        <label>Background Image:</label>
                        <input
                          type='file'
                          accept='image/*'
                          name='bg_image' // Corrected name attribute
                          className='form-control'
                          onChange={changeHandlerBG}
                        />
                        <span className='form-text'>File size, up to 200KB. Add a company background image or watermark for all your meetings and recordings.</span>
                      </div>
                      <div className='separator' />
                      
                      <div className='form-group'>
                        <label>Background Color:</label>
                        <SketchPicker color={bgColor} onChange={(color) => handleBrandingVariation(color)} />
                          <span className='form-text'>You can select either a background image or a background color. Not both.</span>
                      </div>
                      
                    </div>
                    <div className='card-footer'>
                      {!loading ? (
                        <button type="submit" className='secondary-button' disabled={disable}>
                          Submit
                        </button>
                      ) : (
                        <button type='button' className='loading-button' disabled>
                          Loading...
                        </button>
                      )}
                    </div>
                  </form>
                </div>
                
                <div className='col-md-7 header-right'>
                  <h4>Meeting Preview</h4>
                  <span>Once you integrate our API, this is how meetings will look like to your end users with your branding and whitelabelling. Your logo and custom background will also reflect in the recordings as watermark.</span>
                  <div className='browser-mockup'>
                    <div className='browser-header'>
                      <div className='browser-buttons'>
                        <span className='close'></span>
                        <span className='minimize'></span>
                        <span className='maximize'></span>
                      </div>
                      <div className='browser-address-bar'>https://yourdomain.com/meeting</div>
                    </div>
                    <div className='browser-content'>
                      <div
                        className='images-box'
                        style={{
                          backgroundColor: bgColor,
                          backgroundImage: files['bg_image']
                            ? `url(${URL.createObjectURL(files['bg_image'])})`
                            : bgImageLink
                            ? `url(${bgImageLink})`
                            : 'none',
                          backgroundSize: 'cover',
                          backgroundPosition: 'center',
                          backgroundRepeat: 'no-repeat',
                        }}
                      >
                        <div className='logo'>
                          {files['logo_img'] ? (
                            <img src={URL.createObjectURL(files['logo_img'])} alt='Logo preview' />
                          ) : (
                            <img src={logoImageLink || toAbsoluteUrl('/media/avatars/logo.png')} alt='Logo preview' />
                          )}
                        </div>
                        <div className='row justify-content-center'>
                          <div className='col-3 g-1 circleImage' style={{ backgroundColor: bgColor }}>
                            <h1 style={{ color: 'white', fontSize: '70px' }}>S</h1> {/* Placeholder for SaaS - Increased font size */}
                          </div>
                        </div>
                        
                        <img src={toAbsoluteUrl('/media/toolbar.png')} alt="Toolbar preview" className='toolbar-image' />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  )
}
